import Dialog from '@mui/material/Dialog';
import { ReactNode } from 'react';

interface Props {
  text: string | ReactNode;
  onClose: () => void;
  icon?: ReactNode;
}

export const AlertModal = ({
  text, onClose, icon,
}: Props) => (
  <Dialog open>
    <div className="relative p-6">
      <div className="mb-4">
        {icon}
        {text}
      </div>
      <div className="text-right">
        <button type="button" className="btn-primary" onClick={onClose} color="primary">
          Ok
        </button>
      </div>
    </div>
  </Dialog>
);
